// @flow
import { combineReducers } from 'redux';
import { bundleReducer } from './Bundle';
import type { PermanentTopUpAvailableActionType, TopUpAvailableActionType, TopUpSelectedActionType } from './actions';
import { cloneDeep, omit } from 'lodash';

const { INIT_TOP_UP, ADD_TOP_UP_TO_SELECTION, CLEAR_TOP_UP } = require('../../lib/constants').default;

export const topUpAvailableReducer = (state: Object = {}, action: TopUpAvailableActionType) => {
  switch (action.type) {
    case 'SET_AVAILABLE_TOP_UPS': {
      const { topUpType, topUps } = action.payload;

      return {
        ...state,
        [topUpType]: topUps,
      };
    }
    default:
      return state;
  }
};

export const topUpSelectedReducer = (state: Object = {}, action: TopUpSelectedActionType) => {
  switch (action.type) {
    case INIT_TOP_UP:
      return {};
    case CLEAR_TOP_UP:
      return {};
    case ADD_TOP_UP_TO_SELECTION: {
      // $FlowFixMe
      const { topUpToRemove, newTopUp } = action.payload;
      let newState = cloneDeep(state);

      if (topUpToRemove) {
        newState = omit(state, topUpToRemove.ouid);
      }
      if (newTopUp && newTopUp.ouid != null) {
        newState[newTopUp.ouid] = newTopUp;
      }

      return newState;
    }
    default:
      return state;
  }
};

export const permanentTopUpAvailableReducer = (state: Object = [], action: PermanentTopUpAvailableActionType) => {
  switch (action.type) {
    case 'SET_AVAILABLE_PERMANENT_TOP_UPS':
      return action.payload.topUps.EXTRA;
    default:
      return state;
  }
};

export default combineReducers({
  availableByType: topUpAvailableReducer,
  permanent: permanentTopUpAvailableReducer,
  selected: topUpSelectedReducer,
  bundle: bundleReducer,
});
